var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRocket = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 120 119",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m47.95 10.02 1.403-1.414M55.508 2.403 56.9 1M56.9 10.02l-1.392-1.414M49.353 2.403 47.95 1",
  stroke: "#F15B35",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "m49.96 50.361 14.638 14.752",
  stroke: "#A4ABB7",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M90.614 41.811c4.083-2.9 5.06-8.587 2.182-12.702-2.878-4.115-8.52-5.099-12.603-2.199-4.083 2.901-5.06 8.588-2.181 12.702 2.877 4.115 8.52 5.1 12.602 2.2Z",
  stroke: "#F15B35",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M58.338 73.073c13.35-1.486 27.741-8.479 39.593-20.424 15.292-15.412 22.406-35.07 20.159-51.236C102.049-.851 82.546 6.318 67.254 21.73 55.39 33.687 48.464 48.191 46.989 61.634l11.35 11.439Z",
  stroke: "#5C6471",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M66.54 22.461c-9.243 3.526-19.165 10.035-28.092 19.044a96.309 96.309 0 0 0-5.475 6.003l8.693 8.761M63.557 78.332l8.786 8.856a96.149 96.149 0 0 0 5.956-5.52c8.88-8.95 15.327-18.89 18.837-28.158",
  stroke: "#5C6471",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "m29.58 81.315-2.165 2.182M43.198 67.59l-9.664 9.74M37.255 82.883l-8.611 8.68M46.65 73.415l-5.827 5.872M44.72 84.652l-8.073 8.137M52.43 76.893l-3.58 3.608M1.5 70.23a10.04 10.04 0 0 1 1.977-2.83c3.908-3.938 10.261-3.95 14.169 0a10.14 10.14 0 0 1 2.539 9.941M10.836 83.426a5.479 5.479 0 0 1-1.895-1.25 5.57 5.57 0 0 1-.913-6.615M42.743 114.427a5.455 5.455 0 0 1-5.09-1.486 5.524 5.524 0 0 1-1.369-2.299M43.444 102.305a8.43 8.43 0 0 1 10.483 1.203c3.312 3.337 3.312 8.749 0 12.086A8.379 8.379 0 0 1 49.202 118M21.238 72.176a7.022 7.022 0 0 1 7.91.543M46.451 91.055a7.6 7.6 0 0 1 .421 9.434l-.245.318M29.873 101.291a8.59 8.59 0 0 1-9.466-1.875c-2.574-2.594-3.182-6.403-1.837-9.587",
  stroke: "#A4ABB7",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "M91.742 99.817h1.977M102.424 99.817h1.977M98.072 106.196v-1.993M98.072 95.43v-1.993",
  stroke: "#F15B35",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  d: "m113.001 62.53-.386-.389M118.5 68.073l-.386-.39M113.001 67.684l-.386.389M118.5 62.141l-.386.39",
  stroke: "#5C6471",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  d: "M14.136 42.33c1.622 0 2.937-1.324 2.937-2.959s-1.315-2.96-2.937-2.96c-1.622 0-2.937 1.325-2.937 2.96s1.315 2.96 2.937 2.96ZM66.845 103.26a1.08 1.08 0 0 0 1.076-1.085 1.08 1.08 0 0 0-1.076-1.085 1.08 1.08 0 0 0-1.076 1.085 1.08 1.08 0 0 0 1.076 1.085Z",
  stroke: "#A4ABB7",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export default SvgRocket;